import { getWidgetByVar } from "../core/Util.ts";
import $ from "jquery";
import { parseJsonObject, parseString } from "@de-xima/xima-common-js-lang";

/**
 * Takes a `chart.js` chart and creates an image from it. This image is then shown in an overlay dialog so the
 * user can save or print the image. If an remote command is given, it will be called with the data URI
 * containing the exported image. This can be used, for example, to store the data in a bean and provide the
 * user with a download link.
 *
 * @param pfArgs PrimeFaces arguments.
 */
export function exportImage(pfArgs: PrimeFaces.ajax.PrimeFacesArgs): void {
  const data = parseJsonObject(pfArgs.statisticsData);
  const imageFilename = parseString(data.imageFilename);
  const chartWidgetVar = parseString(data.chartWidgetVar);

  const chartWidget = getWidgetByVar(chartWidgetVar, PrimeFaces.widget.BaseChart);
  if (chartWidget === undefined) {
    console.warn("Chart widget not found for widgetVar:", chartWidgetVar);
  } else {
    fetch(chartWidget.exportAsImage().src)
      .then((response) => response.blob())
      .then((blob) => {
        downloadFile(imageFilename, blob);
      });
  }
}

export function downloadFile(filename: string, data: Blob | File | MediaSource): void {
  const url = URL.createObjectURL(data);
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = filename ?? "download";
  const onClick = () => {
    setTimeout(() => {
      URL.revokeObjectURL(url);
    }, 150);
    document.removeEventListener("click", onClick);
  };
  anchor.addEventListener("click", onClick);
  anchor.click();
}

export function setActive(buttonType: string): void {
  $(".fc-statistic-toolbar-buttons .ui-button").removeClass("secondary-btn");
  $(`.fc-statistic-toolbar-buttons .ui-button.${buttonType}`).addClass("secondary-btn");
}
